import {maoMsg$} from '@/raw/mao/index';
import {createOrders$} from '@/spot-utils/orders';
import type {ws} from '@/types';
type MarginOrders = ws.MarginOrders;

export const {orders$: marginOrders$, snapshotOrders$, incrementalOrders$} = createOrders$<MarginOrders>(maoMsg$);
